import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function TotalbyaccountReducer(state = initialState.totalbyaccount, action: any) {
  switch (action.type) {
    case types.SAVE_TOTALBYACCOUNT_SUCCESS:
      return action.totalbyaccount;
    default:
      return state;
  }
}
